import { CartRepositoryInterface } from "../repositories/CartRepositoryInterface";

export class CartRepositoryProvider {
    public constructor(private repository: CartRepositoryInterface) {}
    public getRepository(): CartRepositoryInterface {
        return this.repository;
    }
    public setRepository(repository: CartRepositoryInterface): void {
        this.repository = repository;
    }
}
